import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import AuthImage from '../images/auth/authframe.png';
import Logo from '../images/auth/logo (2).png';

const Login = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value;
        // Only allow digits and enforce max length of 10 (after 234)
        if (/^\d{0,10}$/.test(value)) {
            setPhoneNumber(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);
        
        const fullPhoneNumber = `234${phoneNumber}`;
        const payload = {
            phone_number: fullPhoneNumber,
            channel: 'phone_number'
        };

        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Accept", "application/json");

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(payload),
                redirect: "follow"
            };

            const response = await fetch("https://devapi.quickcare.ng/api/v1/user/passwordless", requestOptions);
            const result = await response.json();

            console.log("Server response:", result);

            if (!response.ok) {
                throw new Error(result.message || 'Login failed');
            }

            // Remove any existing verification IDs
            localStorage.removeItem('quickcare-lg');
            
            // Save verification data to localStorage if it exists
            if (result.data?.lg_id) {
                localStorage.setItem('quickcare-lg', result.data.lg_id);
            }

            // Save the phone number used for login
            localStorage.setItem('quick-care-number-login', fullPhoneNumber);
            
            // Redirect to OTP page
            navigate('/login/otp');
            
        } catch (error) {
            console.error("Login error:", error);
            setError(error.message || 'An error occurred during login');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col md:flex-row bg-white instrument-sans-normal">
            {/* Left side - Form */}
            <div className="w-full md:w-1/2 flex items-center justify-center p-4 md:p-8 lg:p-12">
                <div className="w-full max-w-md space-y-8">
                    <div className="">
                        <img src={Logo} alt="Company Logo" className='w-[196px] h-[49px]'/>
                        <h2 className="mt-6 text-2xl instrument-sans-semibold text-gray-700">
                            Login to Your Account
                        </h2>
                    </div>
                    
                    {error && (
                        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                            <span className="block sm:inline">{error}</span>
                        </div>
                    )}
                    
                    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                        <div>
                            <label htmlFor="phoneNumber" 
                            className="block text-sm font-medium text-[#8B8D8C]"
                            >
                                Phone Number
                            </label>
                            <div className="mt-1 flex rounded-md shadow-sm">
                                <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                                    234
                                </span>
                                <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="tel"
                                    value={phoneNumber}
                                    onChange={handlePhoneNumberChange}
                                    placeholder="8012345678"
                                    maxLength="10"
                                    required
                                    className="flex-1 block w-full rounded-none rounded-r-md border border-gray-300 py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                    disabled={isSubmitting}
                                />
                            </div>
                            <p className="mt-1 text-xs text-gray-500">
                                Enter 10 digits 
                            </p>
                        </div>
                        
                        <div>
                            <button
                                type="submit"
                                className="w-full flex justify-center py-2.5 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#069125] hover:bg-[#057a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-75"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Sending OTP...' : 'Login '}
                            </button>
                        </div>

                        <div className="flex items-center justify-between">
                            <div className="text-sm">
                                <a href="/signup" 
                                className="font-medium text-[#8B8D8C]"
                                >
                                    Don't have an account? 
                                    <span className='text-[#45B139] ml-1'>
                                        Sign up
                                    </span>
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* Right side - Background Image (hidden on mobile) */}
            <div 
                className="hidden md:block md:w-1/2 bg-indigo-50 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${AuthImage})` }}
            >
                {/* Optional: You can add content over the background image here if needed */}
            </div>
        </div>
    );
};

export default Login;